module.exports = __webpack_public_path__ + "img/icon-menu-news-feed.6033a220.svg";